// src/app/core/resolvers/dashboard-data.resolver.ts
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssetManagementDashboardService } from 'src/app/features/asset-management/auth-tools/asset-management-dashboard/dashboard.service';
import { AssetManagementReportService } from 'src/app/features/asset-management/reports/reports.service';

@Injectable({ providedIn: 'root' })
export class AssetManagementDashboardDataResolver implements Resolve<any> {
  constructor(
    private dashboardService: AssetManagementDashboardService,
    private reportService: AssetManagementReportService
  ) {}

  resolve(): Observable<any> {
    const filter = 'all_time';

    return forkJoin({
       dashBoardData: this.dashboardService.getAmDashboardData(),
       data: this.reportService.getAmReports(filter),
       chartdata: this.reportService.getAmDashboardChartData(filter)
    }).pipe(map(response => response));
  }
}
